import { render } from "./LanguageSelectorFlagged.vue?vue&type=template&id=8c95a9be&scoped=true"
import script from "./LanguageSelectorFlagged.vue?vue&type=script&lang=js"
export * from "./LanguageSelectorFlagged.vue?vue&type=script&lang=js"

import "./LanguageSelectorFlagged.vue?vue&type=style&index=0&id=8c95a9be&scoped=true&lang=css"

import exportComponent from "/home/twig/Work/FRONT/adsquiz.front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c95a9be"]])

export default __exports__